import { defineMessages } from 'react-intl';

var messages = defineMessages({
  monthLabel: {
    id: "neptune.DateInput.month.label"
  },
  dayLabel: {
    id: "neptune.DateInput.day.label"
  },
  yearLabel: {
    id: "neptune.DateInput.year.label"
  },
  dayPlaceholder: {
    id: "neptune.DateInput.day.placeholder"
  },
  yearPlaceholder: {
    id: "neptune.DateInput.year.placeholder"
  }
});

export { messages as default };
//# sourceMappingURL=DateInput.messages.mjs.map
